<template>

    <!-- <q-item v-if="isProd" @click="link('mailto:'+utils.infos.email+`?subject=[APPLI] Demande de renseignements - ${user.name} (N°${user.num_societaire})&body=Bonjour`)"
            clickable dense class="q-mt-lg">
        <q-item-section avatar>
            <q-icon name="forward_to_inbox" size="md" color="grey" />
        </q-item-section>
        <q-item-section>
            <q-item-label>Nous Contacter</q-item-label>
            <q-item-label caption>par E-mail</q-item-label>
        </q-item-section>
    </q-item> -->



    <q-item @click="openModalContact()"
            clickable dense class="q-mt-lg"
            id="guidedtour_drawerleft_contact">
        <q-item-section avatar>
            <q-icon name="forward_to_inbox" color="grey" />
            <q-tooltip v-if="tooltip">Nous Contacter</q-tooltip>
        </q-item-section>
        <q-item-section>
            <q-item-label>Nous Contacter</q-item-label>
            <!-- <q-item-label caption>par E-mail</q-item-label> -->
        </q-item-section>
    </q-item>

    <MyDialog v-if="openModal" v-model="openModal" persistent
        title="Contactez Nous par Mail"
        @hide="closeModal()"
        @update:modelValue="closeModal()">

            <q-btn label="Utiliser mon Application de Messagerie" icon-right="forward_to_inbox" color="green-8" no-caps outline class="full-width q-mb-md"
                    @click="openModal = false; link('mailto:'+utils.infos.email+`?subject=${form.subject}&body=Bonjour`)" />


            <JetFormSection @submitted="submit" :form="form"
                            no-show-btn-reset classes="full-width"
                            :show-action=" ! disableForm">

                <template v-if="(form.message?.length || '') > 8" #description>
                    <small class="text-grey-7 q-mt-sm">
                        <q-icon name="info" color="info" size="sm" />
                        Vous pouvez tout à fait fermer cette fenêtre sans perdre votre message<br/>(tant que vous ne rechargez réellement pas la page...)
                    </small>
                </template>

                <template #form>
                    <div class="row full-width">
                        <q-input v-model="form.message" label="Message" type="textarea" class="full-width"
                                 rows="12" counter maxlength="2000"
                                :error="Boolean(form?.errors?.message)"
                                :error-message="form.errors.message"
                                no-error-icon
                                @focus="form.clearErrors('message')"
                                :disable="disableForm" />
                    </div>
                </template>
                <template #actions></template><!-- pour ne pas afficher le "Enregistré" ... -->
            </JetFormSection>
    </MyDialog>


<!-- if Mobile - contact by phone -->

    <q-item v-if="$_isMobile" @click="link('tel:'+utils.infos.phone)"
            clickable dense>
        <q-item-section avatar>
            <q-icon name="phone" size="md" color="grey" />
        </q-item-section>
        <q-item-section>
            <q-item-label>Nous Contacter</q-item-label>
            <q-item-label caption>par Téléphone</q-item-label>
        </q-item-section>
    </q-item>

</template>

<script setup>
// import { useForm } from '@inertiajs/inertia-vue3'
// import { defineAsyncComponent } from '@vue/runtime-core'
import { /* proto,  */pp, app_state, /* $ac, */ notify, link } from '@helpers'
import { ref } from '@vue/reactivity'

import JetFormSection from '@/Jetstream/FormSection.vue'

const props = defineProps({
    tooltip: Boolean,
})

const ppf = pp()


let disableForm =  ref(false)
let openModal =  ref(false)
let form =  ref(null)

const openModalContact = ()=>{
// log('in openModalContact() ContactMail.vue ', pp().user)

    // form.value =  fn.inertiaForm({
    // form.value =  useForm({
    form.value =  proto.$inertia.form({
        // subject:        `[APPLI] Demande de renseignements - ${ppf.user.name}`,// (N°${fn.pp().user.num_societaire})
        // name:           fn.pp().user.name,
        name:           ppf.user.name,
        // email:          fn.pp().user.email,
        email:          ppf.user.email,
        // num_societaire: fn.pp().user.num_societaire,
        // message:        this.$store.state.app.contact_form_message || 'Bonjour,',
        message:        app_state().contact_form_message || 'Bonjour,',
    })

    openModal.value = true
}

const closeModal = ()=>{
    app_state().contact_form_message = form.value.message // save message

    openModal.value = false
}

const submit = ()=>{
    disableForm.value = true

    form.value.post( route('send-contact-form'), {
        preserveScroll: true,
        onSuccess:(res)=> {

            if( ! _.size(res.props?.errors)){

                disableForm.value = false
                openModal.value = false

                // this.$store.state.app.contact_form_message = null
                app_state().contact_form_message = null

                notify('positive', 'Votre message nous a bien été transmis.', 'Nous y répondrons dans les plus bref délais.')
            }
        },
        onError:()=>{
            disableForm.value = false
        }
    })

}

/*

export default {
    name: 'ContactMail',
    components:{
        // MyDialog:       defineAsyncComponent(()=>import('@/components/partials/MyDialog')),
        JetFormSection: $ac(()=>import('@/Jetstream/FormSection.vue')),
    },
    // data(){
    //     return {
    //         disableForm: false,
    //         openModal: false,
    //         form: null,
    //     }
    // },
    setup(props, {attrs}){
        // log('in setup ContactMail.vue', attrs)

        let disableForm =  ref(false)
        let openModal =  ref(false)
        let form =  ref(null)

        return {
            link,

            disableForm,
            openModal,
            form,
    //     }
    // },
    // methods:{
            openModalContact:()=>{
            // log('in openModalContact() ContactMail.vue ', pp().user)

                // form.value =  fn.inertiaForm({
                // form.value =  useForm({
                form.value =  proto.$inertia.form({
                    subject:        `[APPLI] Demande de renseignements - ${attrs.user.name}`,// (N°${fn.pp().user.num_societaire})
                    // name:           fn.pp().user.name,
                    name:           attrs.user.name,
                    // email:          fn.pp().user.email,
                    email:          attrs.user.email,
                    // num_societaire: fn.pp().user.num_societaire,
                    // message:        this.$store.state.app.contact_form_message || 'Bonjour,',
                    message:        app_state().contact_form_message || 'Bonjour,',
                })

                openModal.value = true
            },

            closeModal:()=>{
                // this.$store.state.app.contact_form_message = form.value.message // save message
                app_state().contact_form_message = form.value.message // save message

                openModal.value = false
            },

            submit:()=>{
                // disableForm.value = true

                form.value.post( route('send-contact-form'), {
                    preserveScroll: true,
                    onSuccess:()=> {

                        if( ! _.size(attrs.errors)){

                            disableForm.value = true
                            openModal.value = false

                            // this.$store.state.app.contact_form_message = null
                            app_state().contact_form_message = null

                            notify('positive', 'Votre message nous a bien été transmis.', 'Nous y répondrons dans les plus bref délais.')
                        }
                    },
                    onError:()=>{
                        disableForm.value = false
                    }
                })

            }
        }
    }
} */
</script>
